<template>
    <div :id="'radio--' + component_id">
        <div v-show="options_loaded && passed_filter" class="designeroption">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>
                    {{ title }}
                </span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return "Door Location: ";
                }
            }
        },
        computed: {
            passed_filter(){
                return true;
            },
            url(){
                return '/api/options/' + this.fabricator + '/door-location';
            },
            cache_key(){
                return '_';
            },
        },
        watch: {
            'cache_key': {
                handler: function (val, oldVal) {
                    this.update_options();
                },
            },
        },
    }
</script>
